import axios from 'axios'

axios.interceptors.response.use(async function (response) {
    // 对响应数据做点什么
    if(response.data && response.data.code === 10021) {
        sessionStorage.removeItem("login");
        sessionStorage.removeItem("name");
        sessionStorage.removeItem("token");
        window.location.href = '/'
        return {
            data: {code:500}
        }
    } else {
        return response
    }
}, function (error) {
    return Promise.reject(error)
});

export default axios